module.exports = __webpack_public_path__ + "img/night_m.689bf177.png";